module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetMedium.86c219f.webp";